import { DateTime } from "luxon";

import { Patient, SimplePatient } from "pwapi";

import { CaseDetailPatient } from "shared/reducers/caseDetailReducer";
import { getDateTimefromTimestamp, yearsAgo } from "shared/utils/dates";

export const PatientSexAge = (props: {
  patient: Patient | CaseDetailPatient | SimplePatient;
  shouldDisplayDOB?: boolean;
  dateReported?: {
    timestamp: string;
    timezone?: string;
  };
}) => {
  const { patient, shouldDisplayDOB = true, dateReported } = props;

  const sexDisplay = patient?.sex ? (
    <span title="HL7 single character representation of sex: F, M, O, U, A, N">
      {patient.sex}
    </span>
  ) : (
    <span title="Unknown sex">?</span>
  );

  const formattedDOB = shouldDisplayDOB && patient.date_of_birth && (
    <>
      {" — "}
      <span title="Date of birth">
        {DateTime.fromISO(patient.date_of_birth).toLocaleString()}
      </span>
    </>
  );

  const ageDisplay =
    patient?.date_of_birth && patient.date_of_birth !== "1900-01-01" ? (
      <span className="age">
        <span title="Age">
          {yearsAgo(
            DateTime.fromISO(patient.date_of_birth),
            dateReported
              ? getDateTimefromTimestamp(
                  dateReported.timestamp,
                  dateReported.timezone || "UTC"
                )
              : DateTime.now()
          )}
        </span>
        {formattedDOB}
      </span>
    ) : (
      <span title="Unknown age"> ?</span>
    );

  return (
    <span>
      {sexDisplay}/{ageDisplay}
    </span>
  );
};

export default PatientSexAge;
